
import { defineComponent, computed } from 'vue';
import { useStore } from 'vuex';
import HotelStars from '@/components/HotelStars.vue';

export default defineComponent({
  props: {
    list: Array,
    hasSelected: Boolean,
    cellIndex: Number,
  },
  components: {
    HotelStars,
  },
  setup() {
    const $store = useStore();
    const { hotelInfo, cellResult } = $store.getters;
    const cellIndexFromStore = computed(() => $store.state.cellIndex);
    // const state = computed(() => $store.state);
    // const cell = computed(() => state.value.cells[props.index as number]);
    // const hotelList = computed(() => state.value.result[props.index as number]?.hotel);

    const getTour = (hotel: { tours: { tour: unknown[] } } | false) => {
      if (!hotel || !hotel.tours || !hotel.tours.tour) return false;

      return hotel.tours.tour[0];
    };

    // const setTour = (newTour: unknown) => $store.commit('setTour', newTour);

    const openTour = (hotelcode: string | number, tour: unknown, i = 0) => {
      const e = window.event as Event;
      $store.dispatch('sendStats', {
        cell: $store.state.initials.list[i],
        type: (e.target as HTMLDivElement)?.dataset?.stats,
      });

      $store.commit('setCellIndex', i);

      if (!hotelInfo(hotelcode)) {
        $store.dispatch('getHotel', hotelcode);
      }

      const list = cellResult(i)?.hotel;
      $store.commit('setRelatedList', list);
      $store.dispatch('actualize', tour);
    };
    return {
      getTour,
      // setTour,
      openTour,
      cellIndexFromStore,
      // state,
      // cell,
      // hotelList,
    };
  },
});
